<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :visible.sync="drawerVisible"
    width="1200px"
    :title="drawerTitle"
    :close-on-click-modal="false"
  >
    <el-form v-if="drawerTitle" ref="dataForm" label-width="120px">
      <el-row>
        <el-col :span="8">
          <shortOrderInfo
            :showTitle="false"
            ref="shortOrderInfo"
            :order="order"
          />
        </el-col>
        <el-col :span="16">
          <BaiduMap
           v-if="drawerVisible"
            class="map"
            :center="center"
            :zoom="zoom"
            :scroll-wheel-zoom="true"
            @ready="initMap"
          />
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
  <script>
import workerSelector from "@/components/workerSelector.vue";
import memberSelector from "@/components/memberSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
import shortOrderInfo from "./shortOrderInfo.vue";
import { BaiduMap } from "vue-baidu-map";
export default {
  components: {
    enumSelector2,
    workerSelector,
    memberSelector,
    shortOrderInfo,
    BaiduMap,
  },
  data() {
    return {
      order: "",
      center: {
        lng: 120.306731, //坐标
        lat: 31.581733,
      },
      zoom: 12,
      map: {},
      BMap: {},
      drawerTitle: "查看订单",
      drawerVisible: false,
    };
  },
  methods: {
    show(row) {
      // this.center = {
      //   lng: row.UserAddress.Longitude, //坐标
      //   lat: row.UserAddress.Latitude,
      // };
      
      this.map = "";
      this.BMap = "";
      this.zoom = 12;
      this.order = row;
      this.drawerTitle = "查看订单";
      this.$set(this.center,'lng',row.UserAddress.longitude);
      this.$set(this.center,'lat',row.UserAddress.latitude);
      this.drawerVisible = true;
      
    },
    initMap({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      this.map.centerAndZoom(new BMap.Point(this.center.lng, this.center.lat));
      var marks = new this.BMap.Marker(this.center);
      this.map.addOverlay(marks);
    },
    handleClose() {
      this.drawerVisible = false;
    },
  },
  mounted() {},
};
</script>
      <style lang='scss'  scoped>
.map {
  width: 100%;
  height: 800px;
}
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>